import type { RoomOptions } from 'livekit-client';

/**
 * Oral-exam LiveKit rooms share these options.
 *
 * adaptiveStream picks a simulcast layer from the attached video element's size,
 * so a compact wall tile and a 70% Observe stage do not both pull full resolution.
 * dynacast lets the publisher stop encoding layers nobody is subscribed to.
 *
 * MeetingRoom passes this into `new Room`. Wall tiles pass it as LiveKitRoom
 * `options` and must not also pass `room` (that would ignore `options`).
 */
export const ORAL_EXAM_ROOM_OPTIONS: RoomOptions = {
  adaptiveStream: true,
  dynacast: true,
};
